var map = {
	"./Deutsch.svg": 67983,
	"./French.svg": 74665,
	"./Hungarian.svg": 70028,
	"./Italiano.svg": 30046,
	"./Polski.svg": 54521,
	"./Slovenian.svg": 90510,
	"./Spanish.svg": 99155,
	"./UK.svg": 3353,
	"./US.svg": 3441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51506;